var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 18H12.4444V15.75C14.5867 14.283 16 11.808 16 9V1.8C16 1.32261 15.8127 0.864773 15.4793 0.527208C15.1459 0.189642 14.6937 0 14.2222 0H10.6667C9.68 0 8.88889 0.81 8.88889 1.8V9H0C0 11.781 1.77778 14.4 5.33333 15.75V18ZM2.03556 10.8H13.9644C13.4578 12.519 12.24 13.95 10.6667 14.697V16.2H7.11111V14.697C5.33333 14.4 2.54222 12.519 2.03556 10.8ZM10.6667 1.8H14.2222V9H10.6667V1.8ZM11.5556 2.7V5.4H13.3333V2.7H11.5556Z",
    fill: "#848585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWc);
export default __webpack_public_path__ + "static/media/wc.908d11df3f64a148965016629cf78814.svg";
export { ForwardRef as ReactComponent };